/* Rende il diagramma completo (tutto visibile, tema scuro) in un unico SVG
   autosufficiente con CSS e font incorporati. Base per export SVG e PNG. */
import { initialState, prepare, type DiagramDoc } from "@fullsteps/shared";
import diagramCss from "../generated/diagram.css?raw";
import { renderDiagram } from "../render/diagram.js";
import { NS } from "../render/svg.js";

export interface StandaloneSvg {
  svg: string;
  width: number;
  height: number;
}

export function renderStandaloneSvg(doc: DiagramDoc): StandaloneSvg {
  const model = prepare(doc);
  const S = initialState(); // nessun filtro, nulla di collassato, tema scuro, zoom 1
  const head = document.createElementNS(NS, "svg");
  const diag = document.createElementNS(NS, "svg");

  // renderDiagram imposta data-theme sul root: preservo quello vivo
  const prevTheme = document.documentElement.getAttribute("data-theme");
  renderDiagram(head, diag, model, S);
  if (prevTheme) document.documentElement.setAttribute("data-theme", prevTheme);

  const vbDiag = diag.getAttribute("viewBox")!.split(" ").map(Number);
  const vbHead = head.getAttribute("viewBox")!.split(" ").map(Number);
  const W = vbDiag[2]!;
  const headH = vbHead[3]!;
  const diagH = vbDiag[3]!;
  const H = headH + diagH;

  const svg =
    `<svg xmlns="${NS}" viewBox="0 0 ${W} ${H}" width="${W}" height="${H}">` +
    `<style>${diagramCss}</style>` +
    `<rect x="0" y="0" width="${W}" height="${H}" fill="#111111"/>` +
    `<g transform="translate(0 ${headH})">${diag.innerHTML}</g>` +
    `<g>${head.innerHTML}</g>` +
    `</svg>`;

  return { svg, width: W, height: H };
}
